// Clear, everyday wording with standard chess terms. Keep both languages in step.
const en = {
  'app.tagline': 'Play Free Chess Online',
  'nav.settings': 'Settings',
  'nav.home': 'Home',
  'footer.engine': 'Computer opponent powered by Stockfish (GPLv3).',

  'home.title.a': 'Ready for ',
  'home.title.b': 'a game?',
  'home.lead': 'Choose how you want to play.',
  'home.computer.title': 'Play the computer',
  'home.computer.desc': 'Eight levels, from beginner to master.',
  'home.friend.title': 'Play a friend',
  'home.friend.desc': 'Send them a link and play together.',
  'home.go': 'Play',

  'computer.title': 'Play the computer',
  'computer.level': 'Choose your opponent',
  'computer.otherOpponent': 'Pick another',
  'computer.start': 'Start game',
  'computer.name': 'Computer',
  'computer.levelShort': 'Level {level}',
  'computer.resume': 'You have a game that isn’t finished',
  'computer.resumeButton': 'Keep playing',

  'level.1': 'Caterpillar',
  'level.2': 'Turtle',
  'level.3': 'Bunny',
  'level.4': 'Fox',
  'level.5': 'Owl',
  'level.6': 'Wolf',
  'level.7': 'Eagle',
  'level.8': 'Dragon',
  'level.1.desc': 'Still learning the basics. Makes frequent mistakes.',
  'level.2.desc': 'Plays it safe but often leaves pieces unprotected.',
  'level.3.desc': 'Quick to attack, but misses tactics.',
  'level.4.desc': 'Cunning. Won’t fall for simple traps.',
  'level.5.desc': 'Patient and precise. Punishes careless moves.',
  'level.6.desc': 'A strong player who spots mistakes instantly.',
  'level.7.desc': 'Calculates deep into the position. Very hard to beat.',
  'level.8.desc': 'Master strength. Only the best can beat it.',

  'color.label': 'Choose your colour',
  'color.w': 'White',
  'color.b': 'Black',
  'color.random': 'Random',
  'time.label': 'Clock',
  'time.unlimited': 'No clock',
  'time.minutes': '{n} min',
  'time.increment': '+{n} sec per move',
  'time.incrementShort': '+{n} sec',

  'game.you': 'You',
  'game.thinking': 'Thinking',
  'game.yourTurn': 'Your move',
  'game.checkYou': 'You’re in check!',
  'game.botTurn': '{name} is thinking…',
  'game.theirTurn': 'Opponent’s move',
  'game.toMove': '{color} to move',
  'game.fullscreen': 'Full screen',
  'game.exitFullscreen': 'Exit full screen',
  'game.moves': 'Move list',
  'game.noMoves': 'No moves yet.',
  'game.resign': 'Resign',
  'game.offerDraw': 'Offer a draw',
  'game.drawOffered': 'Draw offered',
  'game.undo': 'Undo',
  'game.hint': 'Hint',
  'game.flip': 'Flip board',
  'game.newGame': 'New game',
  'game.rematch': 'Play again',
  'game.check': 'Check!',
  'game.viewing': 'Viewing an earlier move',
  'game.backToLive': 'Back to the game',
  'game.history.first': 'First move',
  'game.history.prev': 'Previous move',
  'game.history.next': 'Next move',
  'game.history.last': 'Latest move',

  'confirm.resign.title': 'Resign this game?',
  'confirm.resign.body': 'Your opponent will be awarded the win.',
  'common.cancel': 'Keep playing',
  'common.back': 'Back',
  'common.close': 'Close',

  'result.win': 'You won!',
  'result.loss': 'You lost',
  'result.draw': 'Draw',
  'result.whiteWins': 'White wins!',
  'result.blackWins': 'Black wins!',
  'result.winCheer': 'Well played.',
  'result.lossCheer': 'Get it back next game.',
  'result.drawCheer': 'An evenly matched game.',
  'result.moves': '{count} moves',
  'result.move': '{count} move',
  'reason.checkmate': 'Checkmate',
  'reason.resignation': 'Resignation',
  'reason.timeout': 'Timeout',
  'reason.timeout_vs_insufficient': 'Timeout, but the opponent had no mating material',
  'reason.abandonment': 'Forfeit: a player didn’t return in time',
  'reason.stalemate': 'Stalemate',
  'reason.threefold_repetition': 'Threefold repetition',
  'reason.insufficient_material': 'Insufficient material',
  'reason.fifty_move_rule': '50-move rule',
  'reason.agreement': 'Draw by agreement',

  'friend.title': 'Play a friend',
  'friend.playingAs': 'You play as',
  'friend.name': 'Your name:',
  'friend.newName': 'Random name',
  'friend.namePlaceholder': 'Guest',
  'friend.create.title': 'Create a game',
  'friend.create.desc': 'Get a link to send to your friend.',
  'friend.create.button': 'Create game',
  'friend.join.title': 'Join with a code',
  'friend.join.desc': 'Enter the 6-character code your friend sent you.',
  'friend.join.label': 'Game code',
  'friend.join.placeholder': 'e.g. K7M2QX',
  'friend.join.button': 'Join',
  'friend.join.invalid': 'The code is 6 letters and numbers.',
  'friend.join.notFound': 'No game found with this code.',

  'error.rateLimited': 'Too many games started. Wait a minute and try again.',
  'error.network': 'Can’t reach the server. Check your connection and try again.',
  'error.generic': 'Something went wrong. Please try again.',
  'error.illegal_move': 'That piece can’t go there.',
  'error.not_your_turn': 'It’s not your move.',

  'room.connecting': 'Connecting to the game…',
  'room.reconnecting': 'Connection lost. Trying again…',
  'room.waiting.title': 'Waiting for your opponent…',
  'room.waiting.desc': 'Send this link to your friend. The game starts as soon as they open it.',
  'room.code': 'Game code',
  'room.copyLink': 'Copy link',
  'room.copied': 'Copied!',
  'room.share': 'Share',
  'room.shareText': 'Play chess with me on Chessrokko',
  'room.cancel': 'Cancel the game',
  'room.waitingIndicator': 'Waiting for someone to join',
  'room.notFound.title': 'Game not found',
  'room.notFound.desc': 'This game doesn’t exist anymore. Games are removed after 30 minutes without moves.',
  'room.closed.title': 'Game closed',
  'room.closed.desc': 'The person who started this game closed it.',
  'room.spectating': 'You are watching this game',
  'room.online': 'Online',
  'room.offline': 'Offline',
  'room.disconnected': 'Disconnected · {seconds}s',
  'room.opponent': 'Opponent',
  'room.drawOffer': 'Your opponent offers a draw',
  'room.accept': 'Accept',
  'room.decline': 'Decline',
  'room.rematchRequested': 'Waiting for opponent',
  'room.rematchOffered': 'Your opponent wants a rematch',
  'room.acceptRematch': 'Accept rematch',
  'room.game': 'Game {number}',
  'room.home': 'Home',
  'room.newRoom': 'New game',
  'room.opponentAway': 'Your opponent disconnected. If they don’t return within {seconds}s, you win.',
  'room.opponentBack': 'Your opponent is back. The game continues.',
  'room.introTitle': 'Both players are ready!',
  'leave.title': 'Leave the game?',
  'leave.body': 'The game is still on. If you don’t return within {seconds} seconds, you lose by forfeit.',
  'leave.confirm': 'Leave game',

  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.appearance': 'Theme',
  'settings.theme.system': 'Auto',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.board': 'Board',
  'settings.board.ocean': 'Ocean',
  'settings.board.candy': 'Rose',
  'settings.board.meadow': 'Meadow',
  'settings.board.walnut': 'Wood',
  'settings.board.slate': 'Cloud',
  'settings.board.graphite': 'Stone',
  'settings.gameplay': 'Game',
  'settings.sound': 'Sounds',
  'settings.coordinates': 'Show coordinates',
  'settings.legalMoves': 'Show legal moves',
  'settings.autoQueen': 'Always promote to queen',
  'settings.done': 'Done',

  'promotion.title': 'Promote your pawn',
  'piece.q': 'Queen',
  'piece.r': 'Rook',
  'piece.b': 'Bishop',
  'piece.n': 'Knight',

  'auth.signIn': 'Sign in with Google',
  'auth.signInShort': 'Sign in',
  'auth.devSignIn': 'Test sign-in',
  'auth.signOut': 'Sign out',
  'auth.failed': 'Sign-in failed. Please try again.',
  'auth.unavailable': 'Signing in isn’t available right now.',
  'account.title': 'My account',
  'account.rating': 'Your rating',
  'account.games': 'Games',
  'account.wins': 'Wins',
  'account.draws': 'Draws',
  'account.losses': 'Losses',

  'welcome.title': 'Welcome',
  'welcome.lead': 'Pick a username. Other players will see you by this name.',
  'welcome.label': 'Your username',
  'welcome.another': 'Suggest another name',
  'welcome.save': 'Use this name',
  'welcome.rules': '3–20 letters, numbers or _ (no spaces).',
  'welcome.note': 'You can change it later, but it costs gold.',
  'welcome.available': 'Available',
  'welcome.taken': 'This name is taken. Try another one.',
  'welcome.invalid': 'Use 3–20 letters, numbers or _ only.',
  'welcome.checking': 'Checking…',

  'home.online.title': 'Play online',
  'home.online.desc': 'Get matched with a player in seconds.',

  'online.title': 'Play online',
  'online.rating': 'Your rating: {rating}',
  'online.blitz.title': 'Blitz',
  'online.blitz.desc': '5 minutes, +3 seconds each move',
  'online.rapid.title': 'Rapid',
  'online.rapid.desc': '10 minutes',
  'online.searching': 'Looking for an opponent…',
  'online.searchingHint': 'Looking for a player close to your rating.',
  'online.waited': '{seconds} sec',
  'online.cancel': 'Cancel search',
  'online.found': 'Opponent found!',
  'online.startsIn': 'The game starts in',
  'online.needLogin': 'Sign in to play online and earn points.',
  'online.replaced': 'Search started in another tab.',
  'online.error': 'Couldn’t connect. Please try again.',
  'online.retry': 'Try again',

  'room.rated': 'Rated game',
  'room.findNew': 'Find a new opponent',
  'result.ratingChange': 'Your rating: {before} → {after}',
  'result.ratingSame': 'This game didn’t change ratings.',
  'result.menu': 'Main menu',
  'result.review': 'Review the board',
  'rename.button': 'Change name',
  'rename.title': 'Change your username',
  'rename.lead': 'Your new name shows everywhere: in games, on the leaderboard and on your profile.',
  'rename.cost': 'Cost',
  'rename.balance': 'You have',
  'rename.confirm': 'Change name',
  'rename.same': 'This is your current name.',
  'rename.notEnough': 'You need {price} gold. Win games to earn more.',

  'notFound.title': 'Page not found',
  'notFound.desc': 'This page doesn’t exist or has been moved.',

  'nav.leaderboard': 'Leaderboard',
  'nav.market': 'Shop',
  'nav.profile': 'My profile',
  'nav.gifts': 'Gifts',
  'home.leaderboard': 'Leaderboard',
  'home.market': 'Shop',
  'online.guestNote': 'Playing as a guest: you’re matched with other guests. Sign in to earn rating points and gold.',
  'online.searchingGuest': 'Looking for an opponent.',
  'online.guest': 'Guest',
  'gold.amount': '{amount} gold',
  'gold.earned': '+{amount} gold',
  'reward.title': 'Rewards',
  'reward.newBadge': 'New badge!',
  'board.title': 'Leaderboard',
  'board.day': 'Today',
  'board.week': 'This week',
  'board.all': 'All time',
  'board.rating': 'Rating',
  'board.gain': 'Points won',
  'board.games': '{count} games',
  'board.game': '{count} game',
  'board.you': 'You',
  'board.empty': 'No games yet. Play one to take the top spot.',
  'board.prizes': 'The top 3 win a gift box when the {period} ends.',
  'board.prizes.day': 'day',
  'board.prizes.week': 'week',
  'board.endsIn': 'Ends in {time}',
  'board.hours': '{h} h {m} min',
  'board.days': '{d} d {h} h',
  'board.signIn': 'Sign in to get on the leaderboard.',
  'board.loading': 'Loading the leaderboard…',
  'board.error': 'Couldn’t load the leaderboard.',
  'board.retry': 'Try again',
  'profile.title': 'Profile',
  'profile.rank': 'Rank #{rank}',
  'profile.best': 'Best: {rating}',
  'profile.joined': 'Joined {date}',
  'profile.badges': 'Badges',
  'profile.badgesEmpty': 'No badges yet.',
  'profile.edit': 'My look',
  'profile.avatar': 'Avatar',
  'profile.frame': 'Frame',
  'profile.nameStyle': 'Name style',
  'profile.none': 'None',
  'profile.saved': 'Saved',
  'profile.notFound': 'Player not found.',
  'profile.toShop': 'Get more in the shop',
  'profile.locked': 'Not earned yet',
  'shop.title': 'Shop',
  'shop.lead': 'Spend the gold you win in games.',
  'shop.avatars': 'Avatars',
  'shop.frames': 'Frames',
  'shop.names': 'Name styles',
  'shop.buy': 'Buy',
  'shop.notNow': 'Not now',
  'shop.owned': 'Owned',
  'shop.use': 'Use',
  'shop.using': 'In use',
  'shop.boxOnly': 'Only in gift boxes',
  'shop.confirmTitle': 'Buy this?',
  'shop.confirmBody': 'It costs {price} gold. You have {gold}.',
  'shop.notEnough': 'Not enough gold. Win games to earn more.',
  'shop.bought': 'Purchased',
  'shop.signIn': 'Sign in to collect gold and shop.',
  'shop.preview': 'Preview',
  'ads.watch': 'Watch',
  'ads.goldOffer': 'Watch an ad and get {gold} gold',
  'ads.count': 'Ads {done}/{total}',
  'ads.loading': 'Loading…',
  'ads.earned': '+{gold} gold!',
  'ads.progress': 'One step closer: {done}/{total} ads',
  'ads.unlocked': '{name} is yours!',
  'ads.dismissed': 'The ad was closed before the end, so no reward this time.',
  'ads.unavailable': 'No ad available right now. Try again in a moment.',
  'ads.soon': 'Ads are coming soon',
  'ads.test.title': 'Test ad',
  'ads.test.body': 'A real ad plays here once AdSense is set up.',
  'ads.test.wait': 'Reward in {n}',
  'ads.test.claim': 'Get reward',
  'ads.test.close': 'Close',
  'info.nav': 'More about Chessrokko',
  'info.guide': 'How to play',
  'info.about': 'About',
  'info.privacy': 'Privacy',
  'rarity.common': 'Common',
  'rarity.rare': 'Rare',
  'rarity.epic': 'Epic',
  'rarity.legendary': 'Legendary',
  'gifts.title': 'Gift boxes',
  'gifts.lead': 'Finish in the top 3 of the day or week to win one.',
  'gifts.empty': 'No gift boxes yet. Climb the leaderboard to earn one.',
  'gifts.open': 'Open',
  'gifts.opening': 'Opening…',
  'gifts.from': '{place} place · {period}',
  'gifts.place1': '1st',
  'gifts.place2': '2nd',
  'gifts.place3': '3rd',
  'gifts.periodDay': 'Daily',
  'gifts.periodWeek': 'Weekly',
  'gifts.tier.gold': 'Gold box',
  'gifts.tier.silver': 'Silver box',
  'gifts.tier.bronze': 'Bronze box',
  'gifts.youGot': 'You got',
  'gifts.duplicate': 'You already had the item, so it became {amount} gold.',
  'gifts.item': 'New item',
  'gifts.odds': 'What can be inside?',
  'gifts.oddsRow': '{min}–{max} gold · {chance}% chance of an avatar or frame',
  'gifts.opened': 'Opened',
  'badge.first_game': 'First game',
  'badge.first_win': 'First win',
  'badge.wins_10': '10 wins',
  'badge.wins_50': '50 wins',
  'badge.wins_100': '100 wins',
  'badge.games_100': '100 games',
  'badge.streak_3': '3 wins in a row',
  'badge.streak_5': '5 wins in a row',
  'badge.rating_1200': 'Reached 1200',
  'badge.rating_1500': 'Reached 1500',
  'badge.rating_1800': 'Reached 1800',
  'badge.collector_5': 'Collector',
  'badge.rich_1000': '1000 gold',
  'badge.giant_slayer': 'Giant slayer',
  'badge.daily_podium': 'Daily top 3',
  'badge.daily_champion': 'Daily champion',
  'badge.weekly_podium': 'Weekly top 3',
  'badge.weekly_champion': 'Weekly champion',
} as const;

export type MessageKey = keyof typeof en;

const tr: Record<MessageKey, string> = {
  'app.tagline': 'Ücretsiz Online Satranç Oyna',
  'nav.settings': 'Ayarlar',
  'nav.home': 'Ana sayfa',
  'footer.engine': 'Bilgisayar rakibi Stockfish (GPLv3) ile çalışır.',

  'home.title.a': 'Bir oyuna ',
  'home.title.b': 'hazır mısın?',
  'home.lead': 'Nasıl oynamak istediğini seç.',
  'home.computer.title': 'Bilgisayarla oyna',
  'home.computer.desc': 'Acemiden ustaya 8 seviye.',
  'home.friend.title': 'Arkadaşınla oyna',
  'home.friend.desc': 'Bağlantıyı gönder, birlikte oynayın.',
  'home.go': 'Oyna',

  'computer.title': 'Bilgisayarla oyna',
  'computer.level': 'Rakibini seç',
  'computer.otherOpponent': 'Başka rakip',
  'computer.start': 'Oyunu başlat',
  'computer.name': 'Bilgisayar',
  'computer.levelShort': 'Seviye {level}',
  'computer.resume': 'Bitmemiş bir oyunun var',
  'computer.resumeButton': 'Devam et',

  'level.1': 'Tırtıl',
  'level.2': 'Kaplumbağa',
  'level.3': 'Tavşan',
  'level.4': 'Tilki',
  'level.5': 'Baykuş',
  'level.6': 'Kurt',
  'level.7': 'Kartal',
  'level.8': 'Ejderha',
  'level.1.desc': 'Temelleri yeni öğreniyor. Sık sık hata yapar.',
  'level.2.desc': 'Temkinli oynar ama taşlarını sık sık korumasız bırakır.',
  'level.3.desc': 'Hızlı saldırır ama taktikleri kaçırır.',
  'level.4.desc': 'Kurnaz. Basit tuzaklara düşmez.',
  'level.5.desc': 'Sabırlı ve dikkatli. Özensiz hamleleri cezalandırır.',
  'level.6.desc': 'Güçlü bir oyuncu. Hataları anında görür.',
  'level.7.desc': 'Pozisyonu derinlemesine hesaplar. Yenmesi çok zor.',
  'level.8.desc': 'Usta seviyesinde. Onu yalnızca en iyiler yenebilir.',

  'color.label': 'Rengini seç',
  'color.w': 'Beyaz',
  'color.b': 'Siyah',
  'color.random': 'Rastgele',
  'time.label': 'Saat',
  'time.unlimited': 'Saatsiz',
  'time.minutes': '{n} dk',
  'time.increment': 'her hamlede +{n} sn',
  'time.incrementShort': '+{n} sn',

  'game.you': 'Sen',
  'game.thinking': 'Düşünüyor',
  'game.yourTurn': 'Sıra sende',
  'game.checkYou': 'Şah çekildi!',
  'game.botTurn': '{name} düşünüyor…',
  'game.theirTurn': 'Sıra rakibinde',
  'game.toMove': 'Sıra: {color}',
  'game.fullscreen': 'Tam ekran',
  'game.exitFullscreen': 'Tam ekrandan çık',
  'game.moves': 'Hamle listesi',
  'game.noMoves': 'Henüz hamle yok.',
  'game.resign': 'Pes et',
  'game.offerDraw': 'Berabere teklif et',
  'game.drawOffered': 'Teklif gönderildi',
  'game.undo': 'Geri al',
  'game.hint': 'İpucu',
  'game.flip': 'Tahtayı çevir',
  'game.newGame': 'Yeni oyun',
  'game.rematch': 'Tekrar oyna',
  'game.check': 'Şah!',
  'game.viewing': 'Önceki bir hamleye bakıyorsun',
  'game.backToLive': 'Oyuna dön',
  'game.history.first': 'İlk hamle',
  'game.history.prev': 'Önceki hamle',
  'game.history.next': 'Sonraki hamle',
  'game.history.last': 'Son hamle',

  'confirm.resign.title': 'Oyunu bırakmak istiyor musun?',
  'confirm.resign.body': 'Galibiyet rakibine verilecek.',
  'common.cancel': 'Oynamaya devam',
  'common.back': 'Geri',
  'common.close': 'Kapat',

  'result.win': 'Kazandın!',
  'result.loss': 'Kaybettin',
  'result.draw': 'Berabere',
  'result.whiteWins': 'Beyaz kazandı!',
  'result.blackWins': 'Siyah kazandı!',
  'result.winCheer': 'Tebrikler, iyi oyundu.',
  'result.lossCheer': 'Bir sonraki oyunda telafi et.',
  'result.drawCheer': 'Denk bir mücadeleydi.',
  'result.moves': '{count} hamle',
  'result.move': '{count} hamle',
  'reason.checkmate': 'Şah mat',
  'reason.resignation': 'Pes edildi',
  'reason.timeout': 'Süre bitti',
  'reason.timeout_vs_insufficient': 'Süre bitti ama rakibin mat edecek taşı yoktu',
  'reason.abandonment': 'Hükmen: oyuncu süresinde geri dönmedi',
  'reason.stalemate': 'Pat',
  'reason.threefold_repetition': 'Üç kez tekrar',
  'reason.insufficient_material': 'Yetersiz materyal',
  'reason.fifty_move_rule': '50 hamle kuralı',
  'reason.agreement': 'Anlaşmalı beraberlik',

  'friend.title': 'Arkadaşınla oyna',
  'friend.playingAs': 'Oyunda görünecek adın',
  'friend.name': 'Adın:',
  'friend.newName': 'Rastgele isim',
  'friend.namePlaceholder': 'Misafir',
  'friend.create.title': 'Oyun kur',
  'friend.create.desc': 'Arkadaşına gönderebileceğin bir bağlantı al.',
  'friend.create.button': 'Oyunu kur',
  'friend.join.title': 'Koduyla katıl',
  'friend.join.desc': 'Arkadaşının gönderdiği 6 karakterlik kodu gir.',
  'friend.join.label': 'Oyun kodu',
  'friend.join.placeholder': 'örn. K7M2QX',
  'friend.join.button': 'Katıl',
  'friend.join.invalid': 'Kod 6 harf ve rakamdan oluşur.',
  'friend.join.notFound': 'Bu kodla bir oyun bulunamadı.',

  'error.rateLimited': 'Çok fazla oyun kuruldu. Bir dakika bekleyip tekrar dene.',
  'error.network': 'Sunucuya ulaşılamıyor. Bağlantını kontrol edip tekrar dene.',
  'error.generic': 'Bir şeyler ters gitti. Tekrar dene.',
  'error.illegal_move': 'Bu taş oraya gidemez.',
  'error.not_your_turn': 'Sıra sende değil.',

  'room.connecting': 'Oyuna bağlanılıyor…',
  'room.reconnecting': 'Bağlantı koptu. Yeniden deneniyor…',
  'room.waiting.title': 'Rakip bekleniyor…',
  'room.waiting.desc': 'Bu bağlantıyı arkadaşına gönder. Açtığı anda oyun başlar.',
  'room.code': 'Oyun kodu',
  'room.copyLink': 'Bağlantıyı kopyala',
  'room.copied': 'Kopyalandı!',
  'room.share': 'Paylaş',
  'room.shareText': 'Chessrokko’da benimle satranç oyna',
  'room.cancel': 'Oyunu iptal et',
  'room.waitingIndicator': 'Birinin gelmesi bekleniyor',
  'room.notFound.title': 'Oyun bulunamadı',
  'room.notFound.desc': 'Bu oyun artık yok. 30 dakika hamle yapılmayan oyunlar silinir.',
  'room.closed.title': 'Oyun kapandı',
  'room.closed.desc': 'Oyunu kuran kişi oyunu kapattı.',
  'room.spectating': 'Bu oyunu izliyorsun',
  'room.online': 'Bağlı',
  'room.offline': 'Bağlı değil',
  'room.disconnected': 'Ayrıldı · {seconds} sn',
  'room.opponent': 'Rakip',
  'room.drawOffer': 'Rakibin beraberlik teklif ediyor',
  'room.accept': 'Kabul et',
  'room.decline': 'Reddet',
  'room.rematchRequested': 'Rakip bekleniyor',
  'room.rematchOffered': 'Rakibin rövanş istiyor',
  'room.acceptRematch': 'Rövanşı kabul et',
  'room.game': '{number}. oyun',
  'room.home': 'Ana sayfaya dön',
  'room.newRoom': 'Yeni oyun',
  'room.opponentAway': 'Rakibinin bağlantısı koptu. {seconds} sn içinde dönmezse oyunu kazanırsın.',
  'room.opponentBack': 'Rakibin geri döndü, oyun devam ediyor.',
  'room.introTitle': 'İki oyuncu da hazır!',
  'leave.title': 'Oyundan çıkılsın mı?',
  'leave.body': 'Oyun devam ediyor. {seconds} saniye içinde geri dönmezsen oyunu hükmen kaybedersin.',
  'leave.confirm': 'Oyundan çık',

  'settings.title': 'Ayarlar',
  'settings.language': 'Dil',
  'settings.appearance': 'Tema',
  'settings.theme.system': 'Otomatik',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.board': 'Tahta',
  'settings.board.ocean': 'Okyanus',
  'settings.board.candy': 'Gül',
  'settings.board.meadow': 'Çayır',
  'settings.board.walnut': 'Ahşap',
  'settings.board.slate': 'Bulut',
  'settings.board.graphite': 'Taş',
  'settings.gameplay': 'Oyun',
  'settings.sound': 'Sesler',
  'settings.coordinates': 'Koordinatları göster',
  'settings.legalMoves': 'Geçerli hamleleri göster',
  'settings.autoQueen': 'Piyonu her zaman vezire terfi ettir',
  'settings.done': 'Tamam',

  'promotion.title': 'Piyonunu terfi ettir',
  'piece.q': 'Vezir',
  'piece.r': 'Kale',
  'piece.b': 'Fil',
  'piece.n': 'At',

  'auth.signIn': 'Google ile giriş yap',
  'auth.signInShort': 'Giriş yap',
  'auth.devSignIn': 'Test girişi',
  'auth.signOut': 'Çıkış yap',
  'auth.failed': 'Giriş yapılamadı. Tekrar dene.',
  'auth.unavailable': 'Giriş şu anda kullanılamıyor.',
  'account.title': 'Hesabım',
  'account.rating': 'Puanın',
  'account.games': 'Oyun',
  'account.wins': 'Galibiyet',
  'account.draws': 'Beraberlik',
  'account.losses': 'Mağlubiyet',

  'welcome.title': 'Hoş geldin',
  'welcome.lead': 'Kendine bir kullanıcı adı seç. Diğer oyuncular seni bu adla görecek.',
  'welcome.label': 'Kullanıcı adın',
  'welcome.another': 'Başka bir ad öner',
  'welcome.save': 'Bu adı kullan',
  'welcome.rules': '3–20 harf, rakam ya da _ (boşluk ve Türkçe harf yok).',
  'welcome.note': 'Adını sonradan değiştirebilirsin ama bunun için altın gerekir.',
  'welcome.available': 'Bu ad kullanılabilir',
  'welcome.taken': 'Bu ad alınmış. Başka bir tane dene.',
  'welcome.invalid': 'Sadece 3–20 harf, rakam ya da _ kullan.',
  'welcome.checking': 'Kontrol ediliyor…',

  'home.online.title': 'Çevrimiçi oyna',
  'home.online.desc': 'Saniyeler içinde bir oyuncuyla eşleş.',

  'online.title': 'Çevrimiçi oyna',
  'online.rating': 'Puanın: {rating}',
  'online.blitz.title': 'Blitz',
  'online.blitz.desc': '5 dakika, her hamlede +3 saniye',
  'online.rapid.title': 'Rapid',
  'online.rapid.desc': '10 dakika',
  'online.searching': 'Rakip aranıyor…',
  'online.searchingHint': 'Puanına yakın bir oyuncu aranıyor.',
  'online.waited': '{seconds} sn',
  'online.cancel': 'Aramayı iptal et',
  'online.found': 'Rakip bulundu!',
  'online.startsIn': 'Oyun başlıyor',
  'online.needLogin': 'Çevrimiçi oynayıp puan kazanmak için giriş yap.',
  'online.replaced': 'Arama başka bir sekmede başlatıldı.',
  'online.error': 'Bağlantı kurulamadı. Tekrar dene.',
  'online.retry': 'Tekrar dene',

  'room.rated': 'Puanlı oyun',
  'room.findNew': 'Yeni rakip bul',
  'result.ratingChange': 'Puanın: {before} → {after}',
  'result.ratingSame': 'Bu oyun puanları değiştirmedi.',
  'result.menu': 'Ana menü',
  'result.review': 'Tahtayı incele',
  'rename.button': 'İsmi değiştir',
  'rename.title': 'Kullanıcı adını değiştir',
  'rename.lead': 'Yeni adın her yerde görünür: oyunlarda, liderler tablosunda ve profilinde.',
  'rename.cost': 'Ücret',
  'rename.balance': 'Sende:',
  'rename.confirm': 'Adı değiştir',
  'rename.same': 'Bu senin şu anki adın.',
  'rename.notEnough': '{price} altın gerekiyor. Oyun kazanarak altın topla.',

  'notFound.title': 'Sayfa bulunamadı',
  'notFound.desc': 'Bu sayfa mevcut değil ya da taşınmış.',

  'nav.leaderboard': 'Liderler',
  'nav.market': 'Market',
  'nav.profile': 'Profilim',
  'nav.gifts': 'Hediyeler',
  'home.leaderboard': 'Liderler',
  'home.market': 'Market',
  'online.guestNote': 'Misafir olarak oynuyorsun: diğer misafirlerle eşleşirsin. Giriş yaparak puan ve altın kazanabilirsin.',
  'online.searchingGuest': 'Rakip aranıyor.',
  'online.guest': 'Misafir',
  'gold.amount': '{amount} altın',
  'gold.earned': '+{amount} altın',
  'reward.title': 'Ödüller',
  'reward.newBadge': 'Yeni rozet!',
  'board.title': 'Liderler',
  'board.day': 'Bugün',
  'board.week': 'Bu hafta',
  'board.all': 'Tüm zamanlar',
  'board.rating': 'Puan',
  'board.gain': 'Kazanılan puan',
  'board.games': '{count} oyun',
  'board.game': '{count} oyun',
  'board.you': 'Sen',
  'board.empty': 'Henüz oyun yok. Bir oyun oyna, zirveye yerleş.',
  'board.prizes': '{period} bitince ilk 3 kişi hediye kutusu kazanır.',
  'board.prizes.day': 'Gün',
  'board.prizes.week': 'Hafta',
  'board.endsIn': '{time} sonra biter',
  'board.hours': '{h} sa {m} dk',
  'board.days': '{d} gün {h} sa',
  'board.signIn': 'Liderler tablosuna girmek için giriş yap.',
  'board.loading': 'Liderler yükleniyor…',
  'board.error': 'Liderler yüklenemedi.',
  'board.retry': 'Tekrar dene',
  'profile.title': 'Profil',
  'profile.rank': '{rank}. sırada',
  'profile.best': 'En iyi: {rating}',
  'profile.joined': 'Katılım: {date}',
  'profile.badges': 'Rozetler',
  'profile.badgesEmpty': 'Henüz rozet yok.',
  'profile.edit': 'Görünümüm',
  'profile.avatar': 'Avatar',
  'profile.frame': 'Çerçeve',
  'profile.nameStyle': 'İsim süsü',
  'profile.none': 'Yok',
  'profile.saved': 'Kaydedildi',
  'profile.notFound': 'Oyuncu bulunamadı.',
  'profile.toShop': 'Marketten daha fazlasını al',
  'profile.locked': 'Henüz kazanılmadı',
  'shop.title': 'Market',
  'shop.lead': 'Oyunlarda kazandığın altınları burada harca.',
  'shop.avatars': 'Avatarlar',
  'shop.frames': 'Çerçeveler',
  'shop.names': 'İsim süsleri',
  'shop.buy': 'Satın al',
  'shop.notNow': 'Şimdi değil',
  'shop.owned': 'Senin',
  'shop.use': 'Kullan',
  'shop.using': 'Kullanılıyor',
  'shop.boxOnly': 'Sadece hediye kutusunda',
  'shop.confirmTitle': 'Satın alınsın mı?',
  'shop.confirmBody': 'Fiyatı {price} altın. Sende {gold} altın var.',
  'shop.notEnough': 'Yeterli altının yok. Oyun kazanarak altın topla.',
  'shop.bought': 'Satın alındı',
  'shop.signIn': 'Altın toplamak ve alışveriş yapmak için giriş yap.',
  'shop.preview': 'Önizleme',
  'ads.watch': 'İzle',
  'ads.goldOffer': 'Reklam izle, {gold} altın kazan',
  'ads.count': 'Reklam {done}/{total}',
  'ads.loading': 'Yükleniyor…',
  'ads.earned': '+{gold} altın!',
  'ads.progress': 'Bir adım daha: {done}/{total} reklam',
  'ads.unlocked': '{name} artık senin!',
  'ads.dismissed': 'Reklam bitmeden kapandı, bu sefer ödül yok.',
  'ads.unavailable': 'Şu an reklam yok. Biraz sonra tekrar dene.',
  'ads.soon': 'Reklamlar yakında',
  'ads.test.title': 'Deneme reklamı',
  'ads.test.body': 'AdSense ayarlanınca burada gerçek bir reklam oynar.',
  'ads.test.wait': 'Ödüle {n}',
  'ads.test.claim': 'Ödülü al',
  'ads.test.close': 'Kapat',
  'info.nav': 'Chessrokko hakkında daha fazlası',
  'info.guide': 'Nasıl oynanır?',
  'info.about': 'Hakkında',
  'info.privacy': 'Gizlilik',
  'rarity.common': 'Sıradan',
  'rarity.rare': 'Nadir',
  'rarity.epic': 'Destansı',
  'rarity.legendary': 'Efsanevi',
  'gifts.title': 'Hediye kutuları',
  'gifts.lead': 'Günün ya da haftanın ilk 3’üne girersen bir kutu kazanırsın.',
  'gifts.empty': 'Henüz hediye kutun yok. Liderler tablosunda yükselerek kazanabilirsin.',
  'gifts.open': 'Aç',
  'gifts.opening': 'Açılıyor…',
  'gifts.from': '{period} · {place}',
  'gifts.place1': '1.lik',
  'gifts.place2': '2.lik',
  'gifts.place3': '3.lük',
  'gifts.periodDay': 'Günlük',
  'gifts.periodWeek': 'Haftalık',
  'gifts.tier.gold': 'Altın kutu',
  'gifts.tier.silver': 'Gümüş kutu',
  'gifts.tier.bronze': 'Bronz kutu',
  'gifts.youGot': 'Kazandığın',
  'gifts.duplicate': 'Bu eşyan zaten vardı, {amount} altına dönüştü.',
  'gifts.item': 'Yeni eşya',
  'gifts.odds': 'Kutudan neler çıkabilir?',
  'gifts.oddsRow': '{min}–{max} altın · %{chance} ihtimalle avatar ya da çerçeve',
  'gifts.opened': 'Açıldı',
  'badge.first_game': 'İlk oyun',
  'badge.first_win': 'İlk galibiyet',
  'badge.wins_10': '10 galibiyet',
  'badge.wins_50': '50 galibiyet',
  'badge.wins_100': '100 galibiyet',
  'badge.games_100': '100 oyun',
  'badge.streak_3': 'Üst üste 3 galibiyet',
  'badge.streak_5': 'Üst üste 5 galibiyet',
  'badge.rating_1200': '1200 puana ulaştı',
  'badge.rating_1500': '1500 puana ulaştı',
  'badge.rating_1800': '1800 puana ulaştı',
  'badge.collector_5': 'Koleksiyoncu',
  'badge.rich_1000': '1000 altın',
  'badge.giant_slayer': 'Dev avcısı',
  'badge.daily_podium': 'Günün ilk 3’ü',
  'badge.daily_champion': 'Günün şampiyonu',
  'badge.weekly_podium': 'Haftanın ilk 3’ü',
  'badge.weekly_champion': 'Haftanın şampiyonu',
};

export type Locale = 'tr' | 'en';
export const messages: Record<Locale, Record<MessageKey, string>> = { en, tr };
